import React from 'react';
import PropTypes from 'prop-types';
import { get, uniqBy } from 'lodash';
import { menuToggler } from '@bd/bdcore-utilities';
import withData from '@bd/bdcore-data';
import Menu from './Menu';

const createNavComponent = ({ menus: localMenus = [], navs: localNavs = [] }) => {
  class Nav extends React.Component {
    constructor(props) {
      super(props);

      this.state = {};
    }
    componentDidMount() {
      this.setNav();
    }

    componentDidUpdate(prevProps) {
      if (this.props.id !== prevProps.id || this.props.menuId !== prevProps.menuId) {
        this.setNav();
      }
    }

    setNav = () => {
      const { id, menuId, settings } = this.props;

      const navs = get(settings, 'navs2020', []).concat(localNavs);
      const menus = uniqBy(localMenus.concat(get(settings, 'menus2020', [])), 'meta.key');

      const nav = navs.find(navConfig => get(navConfig, 'meta.key') === id);

      let navMenus = get(nav, 'menus', [])
        .map(navMenu => menus.find(menu => get(menu, 'meta.key') === navMenu.key))
        .filter(v => v);

      if (!nav && menuId) {
        navMenus = menus.filter(menu => get(menu, 'meta.key') === menuId);
      }

      this.setState({
        nav,
        menus: navMenus,
      });
    }

    render() {
      const { className, menuProps, activateMenu, isActiveMenu, toggleSubMenus } = this.props;
      const { menus = [] } = this.state;

      return (
        <div className={className}>
          {
            menus.map(menu => {
              const MenuComponent = menu.render ? menu.render : Menu;
              return (
                <MenuComponent
                  key={get(menu, 'meta.key')}
                  {...menuProps}
                  className={[menuProps.className, `NavMenu-${get(menu, 'meta.key')}`].filter(v => v).join(' ')}
                  menu={menu}
                  toggled={toggleSubMenus}
                  activateMenu={activateMenu}
                  isActiveMenu={isActiveMenu}
                />
              );
            })
          }
        </div>
      );
    }
  }

  Nav.propTypes = {
    id: PropTypes.string,
    menuId: PropTypes.string,
    className: PropTypes.string.isRequired,
    menuProps: PropTypes.object.isRequired,
    activateMenu: PropTypes.func.isRequired,
    isActiveMenu: PropTypes.func.isRequired,
    toggleSubMenus: PropTypes.bool,
    settings: PropTypes.object.isRequired,
  };

  Nav.defaultProps = {
    id: undefined,
    menuId: undefined,
    toggleSubMenus: false,
  };

  return withData({
    settings: true,
  })(menuToggler(Nav));
};

export default createNavComponent;



// WEBPACK FOOTER //
// ./src/bdcoreCandidates/Navigation/index.js